import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, first } from 'rxjs/operators';
import { SplashScreenService } from '@luzula/luzula-lib';

@Component({
    standalone: false,
    selector: 'bp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'bpweb';
  private splash = inject(SplashScreenService);

  constructor(private router: Router) {}

  ngOnInit() {
    // Splash Screen wird von AlleBohrpunkteComponent versteckt
    // für andere Routen hier als Fallback verstecken
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      first()
    ).subscribe((event) => {
      const navEvent = event as NavigationEnd;
      // Für andere Routen als die Hauptseite den Splash sofort verstecken
      if (navEvent.url !== '/' && navEvent.url !== '') {
        this.splash.hide();
      }
    });
  }

  @HostListener('document:contextmenu', ['$event'])
  onContextMenu(event: MouseEvent) {
    event.preventDefault();
  }
}
